module.exports = __webpack_public_path__ + "static/media/WCS_logo.3353d9e6.png";